<template>
  <div class="app-deck">
    <Piece v-if="deck[0]" :piece="deck[0]" :index="0" centered />
    <div v-else />
    <Piece v-if="deck[1]" :piece="deck[1]" :index="1" centered />
    <div v-else />
    <Piece v-if="deck[2]" :piece="deck[2]" :index="2" centered />
    <div v-else />
  </div>
</template>

<script>
import { mapState } from "vuex";

import Piece from "./Piece.vue";

export default {
  name: "Deck",
  components: { Piece },
  computed: {
    ...mapState({
      deck: (state) => state.room.room.deck,
    }),
  },
}
</script>

<style scoped>
.app-deck {
  user-select: none;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  width: 50%;
  place-items: center;
  margin-bottom: 144px;
}
</style>
